import { URLS } from '../../../consts/endpoints';
import { getData } from '../../../utils/http';
import { isArray, isObject, isUndefined } from '../../../utils/isDefined';
import React from 'react';

const getProducts = async ({
  setProducts = () => {},
  setIsLoading = () => {},
  accountReference,
  clientId,
  fromEdit = false,
  fromIoT = true,
  skuPrefix,
  subscription = {}
}) => {
  setIsLoading(true);
  try {
    const products = await getData(
      fromIoT
        ? `${URLS.QUOTE_CLIENTS}/${clientId}/products?account_reference=${accountReference}&category=IoT`
        : `${URLS.QUOTE_CLIENTS}/${clientId}/products?account_reference=${accountReference}`
    );

    if (isObject(products)) {
      const productsKeys = Object.keys(products);

      const mappedProducts = mapProducts({
        productsKeys,
        products,
        fromIoT,
        skuPrefix,
        subscription
      });

      if (fromEdit) {
        return mappedProducts;
      }

      setProducts(mappedProducts);
    }
  } catch {
  } finally {
    setIsLoading(false);
  }
};

export default getProducts;

export const mapProducts = ({
  productsKeys,
  products,
  fromIoT,
  skuPrefix,
  subscription
}) => {
  return productsKeys.reduce((obj, key) => {
    if (!products[key] || !isArray(products[key])) {
      return obj;
    }

    let filteredProducts = products[key].filter(el => el.salesAllowed === true);

    if (subscription && subscription.sku) {
      const subscriptionProduct = products[key].find(
        product => product.sku === subscription.sku
      );

      if (subscriptionProduct) {
        if (!fromIoT && subscriptionProduct.category) {
          filteredProducts = filteredProducts.filter(
            el => el.category === subscriptionProduct.category
          );
        }

        if (subscriptionProduct?.specification?.network) {
          filteredProducts = filteredProducts.filter(
            el =>
              el?.specification?.network ===
              subscriptionProduct?.specification?.network
          );
        }
      }
    }

    return {
      ...obj,
      [key]: [
        { value: '', label: '' },
        ...filteredProducts
          .map(el => {
            return {
              ...el,
              value: el.sku,
              label: (
                <div>
                  {el.name}{' '}
                  <small>
                    <i>{mapPrice(el)} DKK</i>
                  </small>
                </div>
              )
            };
          })
          .filter(el => el.createSubscriptionAllowed === true)
          .filter(el => !skuPrefix || el.sku?.startsWith(skuPrefix))
      ]
    };
  }, {});
};

export const mapPrice = product => {
  if (isUndefined(product) || !isArray(product?.prices)) {
    return '-';
  }

  const priceObject = product.prices.find(price => price.sku === product.sku);

  if (isUndefined(priceObject)) {
    return '-';
  }
  const price = priceObject.price;

  if (isUndefined(price) || isNaN(Number(price))) {
    return '-';
  }

  const numericPrice = Number(price) / 100;

  return numericPrice.toLocaleString('da-DK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
